
    import { defineComponent } from 'vue';
    export default defineComponent({
        name: 'WhatsApp',
        methods: {}
    })
